import * as types from './types';

export const setActiveTab = ({ commit }, slug) => {
  commit(types.SET_ACTIVE_TAB, slug);
};

export const resetActiveTab = ({ commit }) => {
  commit(types.RESET_ACTIVE_TAB);
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Downloads/store/actions.js